/**
 * Central route -> permission mapping for private routing.
 *
 * Keys are the exact `path` strings declared on the corresponding <Route> in
 * `router/index.js`. The value is the permission key that must be present in the
 * user's permissions Map (`state.user.get("permissions")`) for the route to render.
 *
 * Routes NOT listed here (e.g. inbox, participated, case details) are open to any
 * authenticated user. To guard a new page, add its path here and use <ProtectedRoute>.
 *
 * Permission keys mirror the `permission` fields in `menu-items.js` so the menu and
 * the route guard stay in sync.
 */
export const ROUTE_PERMISSIONS = {
    "/app/underwriting/jobs": "page_case_underwriting",
    "/app/mpa-approval/": "can_mpa_approve",
    "/app/adhoc": "page_adhoc_edit",
    // Bulk upload is opened from the Adhoc page, so it needs the same permission.
    "/app/bulk-upload": "page_adhoc_edit",
    "/app/payment-program/": "page_dbt_edit",
    "/app/db-onboarding/": "page_dbonboarding_edit",
    "/app/anchor-onboarding/": "page_dbonboarding_edit",
    "/app/reports": "page_reports",
    "/app/reports/:reportId": "page_reports",
    "/app/companies": "page_companies_listing",
    // Hidden from the menu for everyone, but still reachable by URL without these.
    "/app/lenders": "page_lenders_management",
    "/app/bank-accounts": "page_bank_account_management",
    // "/app/schemes": "page_schemes",
    // "/app/schemes/new": "page_schemes",
    // "/app/schemes/:id": "page_schemes",
    // "/app/checklist": "page_checklist",
    // "/app/checklist/new": "page_checklist",
    // "/app/checklist/:id": "page_checklist"
};

/**
 * Routes that, on top of their ROUTE_PERMISSIONS entry, are ALSO hidden from users
 * in the "deferral menu" restricted groups (IDs 7, 11, 16). This mirrors the header
 * menu, which removes db_onboarding / anchor_onboarding for those groups.
 *
 * A user must both hold the route's permission AND not be in a restricted group to
 * access these routes.
 *
 * @see hasRestrictedGroupForDeferralMenu in constants/user-visibility.js
 * @see header-menu.js (menuItemsRemove)
 */
export const DEFERRAL_RESTRICTED_ROUTES = [
    "/app/db-onboarding/",
    "/app/anchor-onboarding/"
];
